import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import axios from 'axios';
import Shape from "../../images/slider/icon.svg";
import sliderData from "../../api/sliderData";
import HeroSlide from "./HeroSlide";

const HeroSlider = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [searchId, setSearchId] = useState('');
    const [checking, setChecking] = useState(false);
    const [error, setError] = useState(null);
    
    console.log("URLLLLLLL",process.env.REACT_APP_API_BASE_URL);

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    console.log("apibaseurl",apiBaseUrl);

    const handleSearchSubmit = async (e) => {
        e.preventDefault();
        const trackingId = searchId.trim();
        if (!trackingId) return;

        setChecking(true);
        setError(null);

        try {
            const response = await axios.get(`${apiBaseUrl}/order-details/tracking/ofl/${encodeURIComponent(trackingId)}`);
            if (response.data && response.data.order) {
                setShowModal(false);
                setSearchId('');
                navigate(`/tracking?id=${encodeURIComponent(trackingId)}`);
                window.scrollTo(10, 0);
            } else {
                setError('Invalid tracking number. Please verify and try again.');
            }
        } catch (err) {
            console.error(err);
            setError('Invalid tracking number. Please verify and try again.');
        } finally {
            setChecking(false);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSearchId('');
        setError(null);
        setChecking(false);
    };

    const settings = {
        autoplay: true,
        speed: 800,
        lazyLoad: "progressive",
        arrows: true,
        dots: false,
        fade: true,
        cssEase: "ease-in-out",
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: false,
                    dots: true,
                },
            },
        ],
    };

    return (
        <section className="hero-section">
            <Slider {...settings} className="hero-slider">
                {sliderData.map((slide) => (
                    <HeroSlide key={slide.id} slide={slide} />
                ))}
            </Slider>

            <div className="track-btn">
                <span className="track-link" onClick={() => setShowModal(true)}>
                    <img src={Shape} alt="" /> Track your shipment
                </span>
            </div>

            {showModal && (
                <div className="track-modal-overlay" onClick={handleCloseModal}>
                    <div className="track-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button 
                            type="button" 
                            className="track-modal-close" 
                            onClick={handleCloseModal}
                        >
                            &times;
                        </button>
                        <h2>Track Your Shipment</h2>
                        <p>Enter your order number or cargo id to view tracking details.</p>
                        <form onSubmit={handleSearchSubmit}>
                            <div className="input-group">
                                <input
                                    type="text"
                                    placeholder="Enter tracking ID or order number..."
                                    value={searchId}
                                    onChange={(e) => {
                                        setSearchId(e.target.value);
                                        if (error) setError(null);
                                    }}
                                    disabled={checking}
                                    autoFocus
                                />
                                <button type="submit" disabled={checking}>
                                    {checking ? 'Checking...' : 'Track Now'}
                                </button>
                            </div>
                        </form>
                        {error && (
                            <div className="modal-error-message mt-3">
                                {error}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </section>
    );
};

export default HeroSlider;